<template>
  <div class="mt-12px">
    <div class="half-graph-container-2">
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          border-bottom
          px-2
          pb-2
        "
      >
        <div class="dashboardAdmin-cards-head ml-2">
          Pending Candidate Feedback
        </div>
        <div class="d-flex align-items-center justify-content-end mr-2 w-50">
          <div v-if="total != null" class="tp-bluetxt mr-4">
            Total Candidate(s): {{ total }}
          </div>
          <div
            class="position-relative w-50"
            v-if="
              pendingCandidates.length ||
              (!pendingCandidates.length && searchQuery != '')
            "
          >
            <span>
              <img
                class="gm-search-pos"
                src="../../assets/img/search-bar-icon.svg"
                alt
              />
            </span>
            <b-form-input
              v-model="searchQuery"
              class="gm-search-input"
              type="search"
              placeholder="Search"
              debounce="500"
            ></b-form-input>
          </div>
        </div>
      </div>
      <b-overlay :show="showSpinner">
        <div class="pcf-main-table">
          <div
            class="pcf-table-head"
            v-if="
              pendingCandidates.length ||
              (!pendingCandidates.length && searchQuery != '')
            "
          >
            <div class="w-17 pl-4">
              Candidate Name
              <template v-if="sortBy == 'candidate.name'">
                <img
                  v-if="sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'candidate.name'),
                      (sortOrder = -1),
                      (page = 0);
                    getPendingCandidateFeedback();
                  "
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'candidate.name'),
                      (sortOrder = 1),
                      (page = 0);

                    getPendingCandidateFeedback();
                  "
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                class="pointer"
                v-else
                @click="
                  (sortByValue = !sortByValue),
                    (sortBy = 'candidate.name'),
                    (sortOrder = 1),
                    (page = 0);
                  getPendingCandidateFeedback();
                "
                src="../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div :class="leadKey ? 'w-15' : 'w-17'">Panelist Name</div>
            <div class="w-15" v-if="leadKey">Recruiter Name</div>
            <div :class="leadKey ? 'w-13' : 'w-19'">
              Job Name
              <template v-if="sortBy == 'jobName'">
                <img
                  v-if="sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'jobName'),
                      (sortOrder = -1),
                      (page = 0);
                    getPendingCandidateFeedback();
                  "
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'jobName'),
                      (sortOrder = 1),
                      (page = 0);

                    getPendingCandidateFeedback();
                  "
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                class="pointer"
                v-else
                @click="
                  (sortBy = 'jobName'), (page = 0), (sortOrder = 1);

                  (sortByValue = true), getPendingCandidateFeedback();
                "
                src="../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>

            <div :class="leadKey ? 'w-17' : 'w-20'">
              Interview Start Date/Time
              <template v-if="sortBy == 'startTime'">
                <img
                  v-if="sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'startTime'),
                      (sortOrder = -1),
                      (page = 0);

                    getPendingCandidateFeedback();
                  "
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'startTime'),
                      (sortOrder = 1),
                      (page = 0);

                    getPendingCandidateFeedback();
                  "
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                class="pointer"
                v-else
                @click="
                  (sortBy = 'startTime'),
                    (sortByValue = true),
                    (sortOrder = 1),
                    (page = 0);

                  getPendingCandidateFeedback();
                "
                src="../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div :class="leadKey ? 'w-15' : 'w-17'">
              Pending for Days
              <template v-if="sortBy == 'pendingFrom'">
                <img
                  v-if="sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'pendingFrom'),
                      (sortOrder = -1),
                      (page = 0);

                    getPendingCandidateFeedback();
                  "
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  class="pointer"
                  @click="
                    (sortByValue = !sortByValue),
                      (sortBy = 'pendingFrom'),
                      (sortOrder = 1),
                      (page = 0);

                    getPendingCandidateFeedback();
                  "
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                class="pointer"
                v-else
                @click="
                  (sortBy = 'pendingFrom'),
                    (sortByValue = true),
                    (sortOrder = 1),
                    (page = 0);

                  getPendingCandidateFeedback();
                "
                src="../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div :class="leadKey ? 'w-8' : 'w-10'">Actions</div>
          </div>
          <div class="pcf-table-body" @scroll="onScroll">
            <div
              v-if="
                !showSpinner &&
                pendingCandidates.length == 0 &&
                searchQuery != ''
              "
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
                h-100
              "
            >
              <div>
                <img
                  src="../../assets/New-imgs/landing-dashboard/no-data-dashboard.svg"
                  alt=""
                />
              </div>
              <div
                v-if="searchQuery != 'Loader' && searchQuery != ''"
                class="mt-2 text-center access-font-color"
              >
                No matching results for
                <span class="access-font-color-b text-center text-break">
                  "{{ searchQuery }}"
                </span>
              </div>
              <div v-else class="mt-2 text-center access-font-color">
                No data found
              </div>
            </div>

            <div
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
                h-100
              "
              v-else-if="
                !showSpinner &&
                pendingCandidates.length == 0 &&
                searchQuery == ''
              "
            >
              <div>
                <img
                  class="mt-4"
                  src="../../assets/New-imgs/landing-dashboard/pending-cand-feddback.svg"
                  alt=""
                />
              </div>
              <div class="text-center access-font-color">
                There are no pending feedback for candidates.
              </div>
            </div>
            <div v-else>
              <div
                v-for="(cand, index) in pendingCandidates"
                :key="index"
                class="pcf-table-row"
              >
                <div class="w-17 position-relative pl-4">
                  <div class="pcf-grid-line"></div>
                  <span class="text-truncate pr-1">
                    <span
                      class="d-inline-block text-truncate"
                      style="min-width: auto; max-width: 80%"
                    >
                      {{ cand.candidate.name }}
                    </span>
                  </span>
                </div>

                <div
                  :class="leadKey ? 'w-15' : 'w-17'"
                  class="position-relative pl-1"
                  v-if="cand.userIcons.length == 1"
                >
                  <div
                    v-for="(icon, iconIndex) in cand.userIcons"
                    :key="iconIndex"
                    class="w-100 text-truncate"
                  >
                    <span
                      class="d-inline-block text-truncate"
                      style="min-width: auto; max-width: 80%"
                    >
                      {{ icon.name }}
                    </span>
                  </div>
                </div>

                <div :class="leadKey ? 'w-15' : 'w-17'" v-else>
                  <div
                    class="d-flex align-items-center position-relative"
                    :style="
                      cand.userIcons && cand.userIcons.length
                        ? 'width: 100px'
                        : cand.userIcons && cand.userIcons.length === 3
                        ? 'width: 70px;'
                        : cand.userIcons && cand.userIcons.length === 2
                        ? 'width: 45px;'
                        : cand.userIcons && cand.userIcons.length === 1
                        ? 'width: 20px;'
                        : ''
                    "
                  >
                    <div
                      v-for="(icon, iconIndex) in cand.userIcons &&
                      cand.userIcons.slice(0, 4)"
                      :key="iconIndex"
                      class="roundDarkBlue"
                      :style="{ left: `${iconIndex * 25}px` }"
                      v-b-tooltip.hover.top="icon.name"
                    >
                      {{ icon.initials }}
                    </div>
                    <div
                      class="roundLightBlue"
                      v-if="cand.userIcons && cand.userIcons.length > 4"
                      :style="{ left: '75px' }"
                      v-b-tooltip.hover.top="
                        getRemainingNamesTooltip(cand.userIcons)
                      "
                    >
                      +{{ cand.userIcons && cand.userIcons.length - 3 }}
                    </div>
                  </div>
                </div>
                <div class="w-15 text-truncate pr-2" v-if="leadKey">
                  <span
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 80%"
                    v-b-tooltip.hover.bottom="cand.createdBy"
                  >
                    {{ cand.createdBy }}
                  </span>
                </div>
                <div
                  :class="leadKey ? 'w-13' : 'w-19'"
                  class="text-truncate pr-2"
                >
                  <span v-b-tooltip.hover.bottom="cand.jobName">
                    {{ cand.jobName }}
                  </span>
                </div>

                <div :class="leadKey ? 'w-17' : 'w-20'" class="pl-1">
                  {{ formatDate(cand.startTime) }}
                </div>
                <div :class="leadKey ? 'w-15' : 'w-17'" class="pl-1">
                  {{ cand.pendingFrom }}
                </div>
                <div
                  :class="leadKey ? 'w-8' : 'w-10'"
                  class="d-flex align-items-center"
                >
                  <img
                    v-b-tooltip.hover="'View'"
                    v-if="
                      cand.candidate.candidateID !=
                      selectedCandidate.candidate.candidateID
                    "
                    @click="viewCandidate(cand)"
                    class="pointer"
                    src="../../assets/talentpool/blueEye.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/talentpool/notviewicon.svg"
                    alt=""
                  />
                  <img
                    v-b-tooltip.hover="'Reminder'"
                    @click="sendRemainder(cand)"
                    class="ml-3 pointer"
                    src="../../assets/New-imgs/landing-dashboard/dashboard-reminder.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div
              style="margin: auto"
              class="d-flex justify-content-center mb-3"
              v-if="showLoader"
            >
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
    <PreviewCandidateSidebar
      v-if="viewCandidateModal"
      :showModal="viewCandidateModal"
      :candidateID="selectedCandidate.candidate.candidateID"
      :customFieldsArray="customFieldsArray"
      :selectedCandidate="selectedCandidate.candidate"
      :showNote="false"
      :showActivate="false"
      @close-view-icon="closeViewIcon"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getDashboardInterviews,
  getCustomerFields,
  panelFeedbackForm,
} from "../../utils/apiFunctions.js";
import PreviewCandidateSidebar from "../../controllers/JD/modals/PreviewCandidateSidebar.vue";
import toast from "../../components/mixin/toast";
export default {
  name: "PendingCandidatesFeedback",
  props: {
    leadKey: Boolean,
  },
  components: {
    PreviewCandidateSidebar,
  },
  mixins: [toast],

  data() {
    return {
      pendingCandidates: [],
      sortOrder: -1,
      showSpinner: false,
      sortByValue: false,
      showLoader: false,
      total: null,
      pageEnd: null,
      viewCandidateModal: false,
      selectedCandidate: {
        candidate: {},
      },
      sortBy: "",
      page: 0,
      searchQuery: "",
      customFieldsArray: [],
      panelEmail: [],
    };
  },
  created() {
    this.showSpinner = true;
    this.getPendingCandidateFeedback();
    this.getCustomField();
    // if(this.$route.query.history){
    //   this.viewCandidate({candidate:this.storedData.candidate});
    // }
  },
  computed: {
    ...mapGetters("jobDescriptionVUEX", {
      storedData: "getSelectedCandidate",
    }),
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.showSpinner = true;
          this.page = 0;
          this.getPendingCandidateFeedback();
        }
      }
    },
  },
  methods: {
    getRemainingNamesTooltip(userIcons) {
      const remainingNames = userIcons.slice(3).map((icon) => icon.name);
      return remainingNames.join(", ");
    },
    async sendRemainder(cand) {
      this.showSpinner = true;

      this.panelEmail = [];
      for (let panel of cand.externalPanelist) {
        this.panelEmail.push(panel);
      }
      for (let panel of cand.panelist) {
        this.panelEmail.push(panel.email);
      }

      let payload = {
        interviewID: cand.interviewID,
        panelEmail: this.panelEmail,
      };

      const res = await panelFeedbackForm(payload);
      if (res.status == 200) {
        this.showSpinner = false;

        this.successModal("Reminder sent successfully");
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);

      const timeOptions = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };

      const dayOptions = {
        weekday: "short",
      };

      const dateOptions = {
        year: "numeric",
        month: "short",
        day: "numeric",
      };

      const timeFormatter = new Intl.DateTimeFormat("en-US", timeOptions);
      const dayFormatter = new Intl.DateTimeFormat("en-US", dayOptions);
      const dateFormatter = new Intl.DateTimeFormat("en-US", dateOptions);

      const formattedTime = timeFormatter.format(date);
      const formattedDay = dayFormatter.format(date);
      const formattedDate = dateFormatter.format(date);

      return `${formattedTime} ${formattedDay}, ${formattedDate}`;
    },
    onScroll(e) {
      // Get the target element of the scroll event.
      const { target } = e;
      // Check if the user has reached the bottom of the scrollable area.
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        // Check if there is more data to load.
        if (
          this.checkbetween(this.pageEnd, 0, this.total) &&
          !this.showLoader
        ) {
          this.showLoader = true;
          this.page++;

          this.getPendingCandidateFeedback();
        }
      }
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
    viewCandidate(cand) {
      this.selectedCandidate = cand;

      this.viewCandidateModal = true;
    },
    closeViewIcon() {
      this.viewCandidateModal = false;
      this.selectedCandidate = {
        candidate: {},
      };
    },
    async getCustomField() {
      try {
        let parentID = "5";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getPendingCandidateFeedback() {
      let payload = {
        count: 10,
        page: this.page,
        searchQuery: this.searchQuery,
        sortBy: this.sortBy == "" ? "startTime" : this.sortBy,
        order: this.sortOrder,
        type: 2,
        lead: this.leadKey,
      };

      try {
        const res = await getDashboardInterviews(payload);
        if (res.status == 200) {
          this.showSpinner = false;
          if (this.page == 0) {
            this.pendingCandidates = res.data.data.data;
          } else {
            this.pendingCandidates = [
              ...this.pendingCandidates,
              ...res.data.data.data,
            ];
          }
          this.total = res.data.data.total;
          this.pageEnd = res.data.data.pageEnd;
          this.LoaderStatus = false;

          this.showLoader = false;
          for (let cand of this.pendingCandidates) {
            const startTime = new Date(cand.startTime);
            const endTime = new Date(cand.endTime);
            const options = {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            };
            cand.formattedStartTime = startTime.toLocaleTimeString(
              "en-US",
              options
            );
            cand.formattedendTime = endTime.toLocaleTimeString(
              "en-US",
              options
            );
            cand.userIcons = [];
            if (cand.externalPanelist && cand.externalPanelist.length) {
              for (let panel of cand.externalPanelist) {
                if (typeof panel === "string") {
                  const initials = panel.includes("@")
                    ? panel[0].toUpperCase()
                    : panel.slice(0, 1).toUpperCase();
                  cand.userIcons.push({ initials, name: panel });
                }
              }
            }
            if (cand.panelist && cand.panelist.length) {
              for (let panel of cand.panelist) {
                if (typeof panel.name === "string") {
                  const initials = panel.name.includes(" ")
                    ? panel.name
                        .split(" ")
                        .map((name) => name && name[0].toUpperCase())
                        .join("")
                    : panel.name.slice(0, 1).toUpperCase();
                  cand.userIcons.push({ initials, name: panel.name });
                }
              }
            }
          }
        } else if (res.status == 500) {
          this.showSpinner = false;
        }
      } catch (error) {
        // this.showLoader = false;
        this.showSpinner = false;
        console.error("Error :", error);
      }
    },

    getInitials(username) {
      return username.includes(" ")
        ? username
            .split(" ")
            .map((name) => name && name[0].toUpperCase())
            .join("")
        : username.slice(0, 2).toUpperCase();
    },
    navigateToLink(cand) {
      if (cand.meetingLink) {
        window.open(cand.meetingLink, "_blank");
      }
    },
  },
};
</script>
